export default __webpack_public_path__ + "static/media/bg.ee24bc46.webp";